<template>
    <Dialog v-model:visible="internalValue" modal :closable="true" class="owners-add-dialog">
        <div v-if="loaded" class="flex w-full gap-5 h-full owners-view justify-content-around align-items-center flex-column overflow-hidden">
            <h2 class="page-header">{{$t('message.owner.headerNew')}}</h2>
            <OwnerForm :selectedOwner="selectedOwner"
                       @createMode="(val) => createMode = val"
                       :countries="countries" ownerAddDialog
                       @closeDialog="() => internalValue = false"
                       @addedNewOwner="addedNewOwner" />
        </div>
    </Dialog>

</template>

<script>
import OwnerTable from "./components/OwnerTable";
import OwnerForm from "./components/OwnerForm.vue";
import LibyanOrnament from "@/components/LibyanOrnament.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import { ScrollToUtils } from "@/utils/ScrollToUtils";
import Dialog from "primevue/dialog";
import {
    getCountries,
} from "@/swagger/vue-api-client";

export default {
    name: "OwnerAddDialog",
    components: {
        OwnerTable,
        OwnerForm,
        LibyanOrnament,
        CustomButton,
        Dialog
    },
    props: {
        modelValue: null,
    },

    data() {
        return {
            selectedOwner: {},
            createMode: true,
            countries: null,
            loaded: false,
        };
    },

    emits: ["addedNewOwner"],

    beforeMount() {
        getCountries()
            .then((response) => {
                this.loaded = true;
                this.countries = response.data;
            });
    },

    mounted() {
        this.selectedOwner = this.getClearOwner();
    },

    methods: {
        getClearOwner() {
            return {
                suffix: null,
                fullName: null,
                business: false,
                businessNumber: null,
                nationalIdNumber: null,
                phone: null,
                address: {
                    street: null,
                    postalCode: null,
                    city: null,
                    region: null,
                    countryId: null,
                    propertyNumber: null,
                    apartmentNumber: null,
                },
                owner: false,
                breeder: false,
                notes: null,
            };
        },
        addNewOwner() {
            this.showForm();
            this.$refs.ownerTable.addNewOwner();
            this.selectedOwner = this.getClearOwner();
            ScrollToUtils.scrollToElement(true);
        },
        addedNewOwner() {
            this.$emit("addedNewOwner");
        }
    },
    computed: {
        internalValue: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit("update:modelValue", value);
            },
        },
    }
};
</script>

<style lang="scss">
.owners-view {
    .section-table {
        min-height: calc(100vh - 230px);
    }
    .section-details {
        height: 0;
        &.showForm {
            height: 100%;
        }
    }
}
.owners-add-dialog.p-dialog {
    .p-dialog-header {
        justify-content: flex-end;
    }
}
</style>
